import { render } from "./App.vue?vue&type=template&id=182f7848"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__